import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import { concatClasses } from '../../utils/fns'

const getClassNames = (props) =>
  concatClasses('formGroup', props.className, props.warning ? '-warning' : '')

export const FormGroup = forwardRef((props, ref) => {
  const { className, warning, ...rest } = props

  return (
    <div ref={ref} className={getClassNames({ className, warning })} {...rest}>
      {props.children}
    </div>
  )
})

FormGroup.displayName = 'FormGroup'

FormGroup.propTypes = {
  className: PropTypes.string,
  warning: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}

FormGroup.defaultProps = {
  className: '',
  warning: false,
}
